export default __webpack_public_path__ + "static/GT-America-Standard-Regular-Italic-1d265c495a65d3b869b9a4688f3b94e6.woff2";